module.exports = __webpack_public_path__ + "img/dollar.8246a210.svg";